'format es6';

Array.prototype.forEach.call(
  document.querySelectorAll('.tabbed-content'),
  (tc_element, index) => {
    Array.prototype.forEach.call(
      tc_element.querySelectorAll('.tabbed-content__tab'),
      (tab_element, index) => {
        tab_element.addEventListener('click', event => {
          event.preventDefault();
          if (tab_element.classList.contains('active')) {
          } else {
            const anchor = tab_element.getAttribute('href').substr(1);
            window.history.replaceState(undefined, undefined, '#' + anchor);
            Array.prototype.forEach.call(
              tc_element.querySelectorAll(
                '.tabbed-content__tab, .tabbed-content__pane',
              ),
              el => {
                el.classList.remove('active');
              },
            );
            tab_element.classList.add('active');
            const pane = tc_element.querySelector(
              `.tabbed-content__pane[id='${anchor}']`,
            );
            if (pane) {
              pane.classList.add('active');
            }

            tc_element.scrollIntoView({
              block: 'start',
              inline: 'nearest',
              behavior: 'smooth',
            });
          }
        });
      },
    );
  },
);

// eslint-disable-next-line no-unused-vars
window.onload = ev => {
  const id = window.location.hash.substr(1);
  const el = document.getElementById(id);
  if (el) {
    const pane = document.querySelector(`.tabbed-content__pane[id='${id}']`);

    if (pane) {
      const tc = pane.closest('.tabbed-content');
      if (tc) {
        Array.prototype.forEach.call(
          tc.querySelectorAll('.tabbed-content__tab'),
          (tab_element, index) => {
            tab_element.classList.remove('active');
            if (tab_element.getAttribute('href') === `#${id}`) {
              tab_element.classList.add('active');
            }
          },
        );
        Array.prototype.forEach.call(
          tc.querySelectorAll('.tabbed-content__pane'),
          (pane_element, index) => {
            pane_element.classList.remove('active');
            if (pane_element.getAttribute('id') === id) {
              pane_element.classList.add('active');
            }
          },
        );
      }
    }

    const y = el.getBoundingClientRect().top + window.pageYOffset;

    setTimeout(() => {
      window.scrollTo({ top: y - 40, behavior: 'smooth' });
    }, 500);
  }

  Array.prototype.forEach.call(
    document.querySelectorAll('.tab-link'),
    (tl_element, index) => {
      tl_element.addEventListener('click', event => {
        let link_id = tl_element.getAttribute('href').split('#');
        if (link_id.length > 1) {
          link_id = link_id[1];
        } else {
          return;
        }

        const pane_el = document.getElementById(link_id);
        if (pane_el) {
          const tc = pane_el.closest('.tabbed-content');
          if (tc) {
            event.preventDefault();
            Array.prototype.forEach.call(
              tc.querySelectorAll('.tabbed-content__tab'),
              (tab_element, index) => {
                tab_element.classList.remove('active');
                if (tab_element.getAttribute('href') === `#${link_id}`) {
                  tab_element.classList.add('active');
                }
              },
            );
            Array.prototype.forEach.call(
              tc.querySelectorAll('.tabbed-content__pane'),
              (pane_element, index) => {
                pane_element.classList.remove('active');
                if (pane_element.getAttribute('id') === link_id) {
                  pane_element.classList.add('active');
                }
              },
            );
            const y = pane_el.getBoundingClientRect().top + window.pageYOffset;

            setTimeout(() => {
              window.scrollTo({ top: y - 40, behavior: 'smooth' });
            }, 100);
          }
        }
      });
    },
  );
};

/*
$tc.find('.tabbed-content__tab').removeClass('active');
            $tc.find(element).addClass('active');
            $tc.find('.tabbed-content__pane').removeClass('active');
            $tc
              .find('.tabbed-content__pane[id=' + anchor + ']')
              .addClass('active');
            $('html, body').animate(
              {
                scrollTop: eval($(element).offset().top - 10),
              },
              300,
            );
 */
